<template>
  <div class="container">
    <h1>
      <!-- <font-awesome-icon icon="home" /> -->
      <b-icon icon="person-square"></b-icon> Military

        <div class="float-right" style="margin-top: -62px">
        <b-button
          v-b-modal.modal-help
          v-b-tooltip.hover
          title="Help"
          class="help"
        >
          <b-icon icon="question-square-fill"></b-icon> Help</b-button
        >

<help id="16" /> 

      </div>
    </h1>

    <div class="row">
      <div class="col-md-3 img-responsive">
        <img
          src="../../assets/101.jpg"
          width="550"
          alt="Circle image"
          class="militray-img"
        />
      </div>
      <div class="col-md-9 pt-4">
        <div class="panal mt-20" style="margin-left: -48px">
          <div class="panal-body row pl-5">
            <h1 class="w-100">Information About Military</h1>
            <p>
            In this page you can choose between booking a military course and see the upcoming courses and make your own reservation , or you can see your history of military courses
            Simply You need to be : 
            <br>
            <ol>
              <li>Egyption</li>
              <li>Male</li>
            </ol>
           
             
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-12 text-center mt-2">
        <div class="row">
          <div class="col-md-6 text-center p-5">
               <b-icon icon="calendar2-date-fill" class="spicon"></b-icon>
              <div class="option">
            <h1 class="pl-5 pr-5">Book Course</h1>
            <p class="pl-5 pr-5">
              IF you would like to book a new course aor make your reservation of one of upcoming courses 
            </p></div>
    <button class="btn btn-primary mr-2" @click="link1">Book Course</button>
        
            

          </div>
            <div class="col-md-6 text-center p-5">
               <b-icon icon="grid-fill" class="spicon"></b-icon>
             
                 <div class="option">
            <h1 class="pl-5 pr-5">Your Course</h1>
            <p class="pl-5 pr-5">
              You can Review all your previous courses and Your results and see when the course start 
            </p>
                 </div>
    <button class="btn btn-primary" @click="link2">View Courses</button>
        
            

          </div>

         
        </div>
       
      </div>
    </div>
  </div>
</template>
<script>
//import ApplicantService from '../../services/Applicant/Applicant.service';
import Help from '../Help.vue';
export default {
  components: { Help },
  name: "Military",
  data() {
    return {
      personalData : [],
      info:[]
    };
  },

  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    link1(){
    
      this.$router.push("/BookCourse");
    },
     link2(){
      this.$router.push("/YourCourse");
    }
  },
 
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
  },

     mounted() {

  
}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}

.option{
  margin: 0px 90px;
}


.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
  border: 1px solid #e5e5e5;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.img-profile {
  border-radius: 50%;
  width: 180px;
  border: 2px solid #285475;
}

.img-user {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  border: 2px dotted #ff8600;
  background: #f2f2f2;
  text-align: center;
  vertical-align: middle;
  padding: 21px;
  float: left;
  margin: 10px;
  font-size: 34px;
}

.active2 {
  background: #285475 !important;
  color: #fff;
}
.title {
  color: #285475;
  font-weight: 700;
  text-align: center;
}
.changeImg {
  margin-top: -40px;
  position: absolute;
  left: 180px;
}
.changeImg a {
  color: #ff8600;
}
.profileData {
  border: 1px dotted #646464;
  color: #285475;
  padding: 3px 10px;
  font-weight: 700;
}
.spicon{
   color: #ff8600;
   font-size: 45px;
   font-weight: 800;

}
.profileData2 {
  border: 1px dotted #646464;
  color: #ff8600;
  padding: 3px 10px;
  font-weight: 700;
}
.clearfix {
  clear: both;
  display: table;
}
.line1 {
  border-top: 1px dotted #285475;
  border-bottom: 1px dotted #285475;
  height: 10px;
  width: 114px;
  float: left;
  margin-top: 57px;
}
.militray-img {
  width: 550px;
}

@media only screen and (max-width: 600px) {
  .militray-img {
    width: 75vw !important;
  }
  .panal {
    margin-left: 3px !important;
  }
  .option{
    margin: 2px;
  }
  .option .pl-5{
    padding: 2px !important;
  }
}
@media only screen and (min-width: 500px) and (max-width : 990px) { 
.option .pl-5{
    padding: 20px ;
  }
  .option{
    margin: 2px;
  }
}

</style>
